export const globalThisShim = (() => {
    if (typeof self !== "undefined") {
        return self;
    }
    else if (typeof window !== "undefined") {
        return window;
    }
    else {
        return Function("return this")();
    }
})();



//////////////////
// WEBPACK FOOTER
// ./node_modules/engine.io-client/build/esm/globalThis.browser.js
// module id = KXQW
// module chunks = 1